import { AddressSearchResponse } from 'Services';

export const addressesSearchResponse: AddressSearchResponse = {
  lines: [
    {
      displayedOutput: '1B RUE DU TRAITRE-20080 AHMED CITY',
      streetNumber: '1',
      additionalStreetNumber: 'B',
      streetName: 'RUE DU TRAITRE',
      zipCode: '20080',
      city: 'AHMED CITY',
    },
    {
      displayedOutput: '1 RUE DE LA TRAHISON-20081 AHMED TOWN',
      streetNumber: '1',
      streetName: 'RUE DE LA TRAHISON',
      zipCode: '20081',
      city: 'AHMED TOWN',
    },
    {
      displayedOutput: '1T RUE DE LA MOULA-20082 MOUHILA',
      streetNumber: '1',
      additionalStreetNumber: 'T',
      streetName: 'RUE DE LA MOULA',
      zipCode: '20082',
      city: 'MOUHLILA',
    },
    {
      displayedOutput: '1 RUE DU BUG-20083 GERIENFE',
      streetNumber: '1',
      streetName: 'RUE DU BUG',
      zipCode: '20083',
      city: 'GERIENFE',
    },
    {
      displayedOutput: '8 RUE DE BATEAUX LAVOIRS-94200 IVRY SUR SEINE',
      streetNumber: '8',
      streetName: 'RUE DE BATEAUX LAVOIRS',
      zipCode: '94200',
      city: 'IVRY SUR SEINE',
    },
    {
      displayedOutput: '1 RUE DES BOUHLILAS-20084 MOULAGA',
      streetNumber: '1',
      streetName: 'RUE DES BOUHLILAS',
      zipCode: '20084',
      city: 'MOULAGA',
    },
  ],
};
